import { createClient } from '@supabase/supabase-js';

// Overridable per environment (e.g. a Netlify branch deploy or local dev pointed at a
// test database) via REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY; defaults to live.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://vtfnxhwyfcvpdpfcmuyp.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0Zm54aHd5ZmN2cGRwZmNtdXlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE1MjY3NjcsImV4cCI6MjA5NzEwMjc2N30.oZabZyobmAoAfxzpGPmbFh6wwcz3zln0FQGPPInwMlo';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
